import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { fmtDate } from "@/lib/api";
import { PageHeader, Loading, EmptyState } from "@/components/Shared";
import { Bell, ShoppingCart, Newspaper, UserCheck, ClipboardCheck, Circle } from "lucide-react";

const ICONS = { operation: ShoppingCart, news: Newspaper, account: UserCheck, order: ClipboardCheck };

export default function Notifications() {
  const [items, setItems] = useState(null);

  const load = () => api.get("/notifications").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await api.post(`/notifications/${id}/read`);
    load();
  };

  if (items === null) return <Loading />;

  return (
    <div>
      <PageHeader title="Notifications" subtitle="Restez informé des opérations, commandes et actualités." />
      {items.length === 0 ? (
        <EmptyState title="Aucune notification" subtitle="Vous êtes à jour !" icon={Bell} />
      ) : (
        <div className="space-y-2.5">
          {items.map((n) => {
            const Icon = ICONS[n.type] || Bell;
            return (
              <div key={n.id} onClick={() => !n.read && markRead(n.id)} data-testid={`notif-${n.id}`}
                className={`flex items-start gap-4 p-4 rounded-xl border transition-colors duration-200 cursor-pointer ${n.read ? "bg-white border-slate-200" : "bg-indigo-50/40 border-indigo-200"}`}>
                <span className={`h-10 w-10 rounded-lg grid place-items-center shrink-0 ${n.read ? "bg-slate-100 text-slate-400" : "bg-indigo-100 text-indigo-600"}`}><Icon className="h-5 w-5" /></span>
                <div className="flex-1 min-w-0">
                  <div className="font-bold text-slate-900 text-sm">{n.title}</div>
                  <div className="text-sm text-slate-600 mt-0.5">{n.message}</div>
                  <div className="text-xs text-slate-400 mt-1">{fmtDate(n.created_at)}{n.link && <Link to={n.link} className="ml-2 font-semibold text-indigo-600 hover:underline" onClick={(e) => e.stopPropagation()}>Voir</Link>}</div>
                </div>
                {!n.read && <Circle className="h-2.5 w-2.5 fill-indigo-600 text-indigo-600 mt-1.5 shrink-0" />}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
